// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 991.98px) {
    .app-header .navbar-toggler {
        display: block; /* Đảm bảo nút hiển thị */
        z-index: 2000; /* Đặt z-index cao hơn */
    }
}
.navbar-toggler {
    display: block !important; /* Đảm bảo nó luôn hiển thị */
    position: relative; /* Đảm bảo nó không bị ẩn bởi các yếu tố khác */
    z-index: 2000; /* Đặt z-index cao hơn để tránh bị che khuất */
}


  
  
  `, "",{"version":3,"sources":["webpack://./src/css/sidebar.css"],"names":[],"mappings":"AAAA;IACI;QACI,cAAc,EAAE,yBAAyB;QACzC,aAAa,EAAE,wBAAwB;IAC3C;AACJ;AACA;IACI,yBAAyB,EAAE,6BAA6B;IACxD,kBAAkB,EAAE,+CAA+C;IACnE,aAAa,EAAE,8CAA8C;AACjE","sourcesContent":["@media (max-width: 991.98px) {\n    .app-header .navbar-toggler {\n        display: block; /* Đảm bảo nút hiển thị */\n        z-index: 2000; /* Đặt z-index cao hơn */\n    }\n}\n.navbar-toggler {\n    display: block !important; /* Đảm bảo nó luôn hiển thị */\n    position: relative; /* Đảm bảo nó không bị ẩn bởi các yếu tố khác */\n    z-index: 2000; /* Đặt z-index cao hơn để tránh bị che khuất */\n}\n\n\n  \n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
